import { Icon } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { IconType } from '@/components/core/components/atoms/icon/icons';
import InternalLink from '@/components/core/components/organism/internal-link';
import clsx from 'clsx';
import * as styles from './item.styles';

const Item: UIComponent<{ icon: IconType }, typeof InternalLink> = ({ children, icon, className, href, ...props }) => {
  return (
    <InternalLink href={href} className={clsx(styles.root, className)} {...props}>
      <Icon name={icon} />
      <span className={styles.label}>{children}</span>
    </InternalLink>
  );
};

export default Item;
